<template>
    <div class="msg">
        <div class="header">
            <div class="title">留言咨询</div>
            <div class="intro">随时告诉我们你的需要</div>
        </div>
        <div class="form">
            <div class="form_item mt_18">
                <div class="label ta_left"> <span style="color: #f00">*</span> 姓名</div>
                <input type="text" v-model="formData.name" placeholder="请输入您的姓名" class="mt_4">
            </div>
            <div class="form_item mt_18">
                <div class="label ta_left"> <span style="color: #f00">*</span>手机号码</div>
                <input type="text" v-model="formData.mobile" placeholder="请输入您的手机号码" class="mt_4">
            </div>
            <div class="form_item mt_18">
                <div class="label ta_left">联系地址</div>
                <input type="text" v-model="formData.address" placeholder="请输入您的联系地址" class="mt_4">
            </div>
            <div class="form_item mt_18">
                <div class="label ta_left">详细需求</div>
                <textarea placeholder="请输入您的详细需求" v-model="formData.content" class="mt_4"></textarea>
            </div>
            <div class="send_area row_center">
                <div class="send row_center" @click="sumbit">
                    发送
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {msgConsult} from "../../pc-project/api/common";
    export default {
        name: "mslMsg",
        data () {
            return {
                formData: {
                    name: '',
                    mobile: '',
                    address: '', // 联系地址
                    content: ''
                },
            }
        },
        methods: {
            sumbit () {
                if(!this.formData.name) {
                    this.$toast.fail('请输入姓名');
                    return
                }
                if(!this.formData.mobile) {
                    this.$toast.fail('请输入手机号码');
                    return
                }

                var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
                if (!myreg.test(this.formData.mobile)) {
                    this.$toast.fail('请输入正确手机号码')
                    return
                }

                try {
                    msgConsult(this.formData).then(res => {
                        if(res.code == 1) {
                            this.$toast.success(res.msg)
                            this.formData = {
                                name: '',
                                mobile: '',
                                address: '',
                                content: ''
                            }
                            this.$emit('finish', false)
                        }
                    })
                } catch {
                    this.errToast('留言失败，请重试')
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .msg {
        padding: 32px 24px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
        border-radius: 4px;
        .header {
            .title {
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: bold;
                line-height: 24px;
                color: #262626;
            }
            .intro {
                margin-top: 4px;
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 18px;
                color: #8C8C8C;
            }
        }
        .form {
            margin-top: 16px;
            .form_item {
                width: 100%;
                .label {
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 18px;
                    color: #262626;
                }
                input, textarea {
                    width: 100%;
                    padding: 10px;
                    box-sizing: border-box;
                    border: 1px solid #F0F0F0;
                    border-radius: 4px;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 24px;
                    color: #262626;
                }
                input::-webkit-input-placeholder {
                    font-size: 14px;
                    color: #bfbfbf;
                }
                textarea::-webkit-input-placeholder {
                    font-size: 14px;
                    color: #bfbfbf;
                }
                textarea {
                    width: 100%;
                    height: 105px;
                }
            }
            .mt_4 {
                margin-top: 4px;
            }
            .mt_18 {
                margin-top: 18px;
            }
            .send_area {
                width: 100%;
                margin-top: 24px;
                .send {
                    width: 263px;
                    height: 42px;
                    background: #262626;
                    border-radius: 2px;
                    font-size: 16px;
                    font-family: Alibaba PuHuiTi;
                    font-weight: 400;
                    line-height: 22px;
                    color: #FFFFFF;
                }
            }
        }
    }
</style>
